export default __webpack_public_path__ + "static/media/highSpeedCorridor.a3134a45.jpg";